module.exports = __webpack_public_path__ + "img/login_title.eb63eb8d.png";